import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Login } from '../models/LoginView';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly urlPath = 'vendor-portal-users';

  constructor(private httpClient: HttpClient) {}

  singup(request: any, prefix: string): Observable<Login> {
    return this.httpClient
      .post<Login>(
        `${environment.apiUrl}${this.urlPath}`,
        this.setupRequest(request, prefix),
      )
      .pipe();
  }

  private setupRequest(request: any, prefix: string) {
    const formData: FormData = new FormData();
    formData.append('model', JSON.stringify(request));
    return formData;
  }
}
